var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import Row from './Row';
import Seat from './Seat';
import Blank from './Blank';
var SeatPicker = /** @class */ (function (_super) {
    __extends(SeatPicker, _super);
    function SeatPicker(props) {
        var _this = _super.call(this, props) || this;
        /*static getDerivedStateFromProps(props, state) {
          if (props.maxReservableSeats < state.size) {
            let sum = 0;
            const selectedSeats = {};
            for (const array in state.selectedSeats) {
              if (state.selectedSeats.hasOwnProperty(array)) {
                const {length} = state.selectedSeats[array]
                if (
                  sum + length <
                  props.maxReservableSeats
                ) {
                  selectedSeats[array] = state.selectedSeats[array].slice(0);
                } else {
                  const dif = props.maxReservableSeats - sum;
                  selectedSeats[array] = state.selectedSeats[array].slice(0, dif);
                  return {
                    selectedSeats: selectedSeats,
                    size: props.maxReservableSeats,
                  };
                }
                sum = sum + state.selectedSeats[array].length;
              }
            }
          }
          return null;
        }*/
        /*shouldComponentUpdate(nextProps, nextState) {
          return (
            nextState.selectedSeats !== this.state.selectedSeats ||
            this.props.loading !== nextProps.loading
          );
        }*/
        _this.getAlreadySelectedSeats = function () {
            var selectedSeats = {};
            var size = 0;
            var _a = _this.props, maxReservableSeats = _a.maxReservableSeats, alpha = _a.alpha, selectedByDefault = _a.selectedByDefault;
            if (selectedByDefault) {
                _this.props.rows.forEach(function (row, index) {
                    var rowNumber = alpha
                        ? String.fromCharCode('A'.charCodeAt(0) + index)
                        : (index + 1).toString();
                    row.forEach(function (seat) {
                        if (seat && seat.isSelected) {
                            var seatAlreadySelected = _this.includeSeat(selectedSeats, rowNumber, seat.numero);
                            if (size < maxReservableSeats && !seatAlreadySelected) {
                                selectedSeats = _this.addSeat(selectedSeats, rowNumber, seat.numero, seat.id);
                                size = size + 1;
                            }
                        }
                    });
                });
            }
            return { selectedSeats: selectedSeats, size: size };
        };
        _this.includeSeat = function (selectedSeats, row, numero) {
            if (selectedSeats[row]) {
                return !!selectedSeats[row][numero];
            }
            return false;
        };
        _this.addSeat = function (selectedSeats, row, numero, id) {
            if (selectedSeats[row]) {
                if (!selectedSeats[row][numero]) {
                    selectedSeats[row][numero] = id;
                }
            }
            else {
                selectedSeats[row] = {};
                selectedSeats[row][numero] = id;
            }
            return __assign({}, selectedSeats);
        };
        _this.deleteSeat = function (row, numero) {
            var selectedSeats = _this.state.selectedSeats;
            if (selectedSeats[row]) {
                delete selectedSeats[row][numero];
                if (!(Object.keys(selectedSeats[row]).length > 0)) {
                    delete selectedSeats[row];
                }
            }
            return __assign({}, selectedSeats);
        };
        _this.addTooltip = function (tooltipOverrides, row, numero, tooltip) {
            if (!tooltipOverrides[row]) {
                tooltipOverrides[row] = {};
            }
            tooltipOverrides[row][numero] = tooltip;
            return __assign({}, tooltipOverrides);
        };
        _this.acceptSelection = function (row, numero, id, tooltip) {
            var _a = _this.state, selectedSeats = _a.selectedSeats, tooltipOverrides = _a.tooltipOverrides, size = _a.size;
            var maxReservableSeats = _this.props.maxReservableSeats;
            if (size < maxReservableSeats) {
                _this.setState({
                    tooltipOverrides: _this.addTooltip(tooltipOverrides, row, numero, tooltip),
                    selectedSeats: _this.addSeat(selectedSeats, row, numero, id),
                    size: size + 1,
                });
            }
        };
        _this.acceptDeselection = function (row, numero, tooltip) {
            var _a = _this.state, size = _a.size, tooltipOverrides = _a.tooltipOverrides;
            _this.setState({
                tooltipOverrides: _this.addTooltip(tooltipOverrides, row, numero, tooltip),
                selectedSeats: _this.deleteSeat(row, numero),
                size: size - 1,
            });
        };
        _this.acceptLastDeselectionAcceptSelection = function (rowToDelete, numeroToDelete, tooltip, rowNew, numeroNew, idNew) {
            var _a = _this.state, size = _a.size, tooltipOverrides = _a.tooltipOverrides;
            _this.setState({
                tooltipOverrides: _this.addTooltip(tooltipOverrides, rowNew, numeroNew, tooltip),
                selectedSeats: _this.deleteSeat(rowToDelete, numeroToDelete),
                // size: size - 1,
            }, function () {
                _this.setState({
                    tooltipOverrides: _this.addTooltip(tooltipOverrides, rowNew, numeroNew, tooltip),
                    selectedSeats: _this.addSeat(_this.state.selectedSeats, rowNew, numeroNew, idNew),
                    // size: size + 1,
                });
            });
        };
        _this.selectSeat = function (row, numero, id) {
            var selectedSeats = _this.state.selectedSeats;
            var size = _this.state.size;
            var _a = _this.props, maxReservableSeats = _a.maxReservableSeats, addSeatCallback = _a.addSeatCallback, removeSeatCallback = _a.removeSeatCallback, continuous = _a.continuous;
            var seatAlreadySelected = _this.includeSeat(selectedSeats, row, numero);
            if (seatAlreadySelected) {
                removeSeatCallback({ row: row, numero: numero, id: id }, _this.acceptDeselection);
            }
            else {
                if (size < maxReservableSeats) {
                    addSeatCallback({ row: row, numero: numero, id: id }, _this.acceptSelection);
                }
                else if (continuous) {
                    var auxRow = Object.keys(selectedSeats)[0];
                    var auxNumber = Object.keys(selectedSeats[auxRow])[0];
                    addSeatCallback({ row: row, numero: numero, id: id }, _this.acceptSelection, 
                    // @ts-ignore
                    {
                        row: auxRow,
                        numero: auxNumber,
                        id: selectedSeats[auxRow][auxNumber],
                    }, _this.acceptLastDeselectionAcceptSelection);
                }
            }
        };
        var rows = props.rows;
        var _a = _this.getAlreadySelectedSeats(), selectedSeats = _a.selectedSeats, size = _a.size;
        _this.state = {
            tooltipOverrides: {},
            selectedSeats: selectedSeats,
            size: size,
            rowLength: Math.max.apply(null, rows.map(function (row) { return row.length; })),
        };
        return _this;
    }
    SeatPicker.prototype.render = function () {
        var selectedSeats = this.state.selectedSeats;
        if (this.props.offsets && this.props.rows.length !== this.props.offsets.length) {
            return React.createElement("div", null, 'rows y offsets no coinciden en número');
        }
        return (React.createElement("div", { className: "seat-content elements selecto-area", id: 'selecto1' },
            React.createElement("div", { className: this.props.loading ? 'loader' : null }),
            React.createElement("div", { className: "seat-picker" }, this.renderRows())));
    };
    SeatPicker.prototype.renderRows = function () {
        var _this = this;
        var seats = this.state.selectedSeats;
        var _a = this.props, alpha = _a.alpha, visible = _a.visible, offsets = _a.offsets, rows = _a.rows;
        return rows.map(function (row, index) {
            // Busco la altura
            var offsetsTop = [];
            var offsetsBottom = [];
            row.forEach(function (seat) {
                if (seat && seat.offsetTop) {
                    offsetsTop.push(seat.offsetTop);
                }
                if (seat && seat.offsetTop) {
                    offsetsBottom.push(seat.offsetBottom);
                }
            });
            // busco el mayor de Top y el mayor de Bottom
            var maxTop = Math.max.apply(Math, offsetsTop);
            var maxBottom = Math.max.apply(Math, offsetsBottom);
            var height = 30 + maxTop + maxBottom;
            var rowNumber = alpha
                ? String.fromCharCode('A'.charCodeAt(0) + index)
                : (index + 1).toString();
            var isSelected = !!seats[rowNumber];
            var props = {
                visible: visible,
                rowNumber: rowNumber,
                isSelected: isSelected,
                selectedSeat: null,
                seats: row,
                // key: `Row${rowNumber}`,
                selectSeat: _this.selectSeat,
                offset: offsets ? offsets[index] : 0,
                height: height
            };
            return (React.createElement(Row, __assign({ key: index }, props),
                _this.renderSeats(row, rowNumber, isSelected),
                ' '));
        });
    };
    SeatPicker.prototype.renderSeats = function (seats, rowNumber, isRowSelected) {
        var _this = this;
        var _a = this.state, selectedSeats = _a.selectedSeats, size = _a.size, rowLength = _a.rowLength, tooltipOverrides = _a.tooltipOverrides;
        var _b = this.props, maxReservableSeats = _b.maxReservableSeats, continuous = _b.continuous, showNumber = _b.showNumber;
        var blanks = new Array(rowLength - seats.length > 0 ? rowLength - seats.length : 0).fill(0);
        var row = seats.map(function (seat, index) {
            if (seat === null)
                return React.createElement(Blank, { key: index, seat: seat });
            var isSelected = isRowSelected &&
                _this.includeSeat(selectedSeats, rowNumber, seat.numero);
            var tooltip = seat.tooltip;
            if (tooltipOverrides[rowNumber] &&
                tooltipOverrides[rowNumber][seat.numero] != null) {
                tooltip = tooltipOverrides[rowNumber][seat.numero];
            }
            var props = {
                isSelected: isSelected,
                orientation: seat.orientation,
                isReserved: seat.isReserved,
                tooltip: tooltip,
                isEnabled: size < maxReservableSeats || continuous,
                selectSeat: _this.selectSeat.bind(_this, rowNumber, seat.numero, seat.id),
                seatNumber: seat.numero,
                tooltipProps: _this.props.tooltipProps,
                offsetLeft: seat.offsetLeft,
                offsetRight: seat.offsetRight,
                offsetTop: seat.offsetTop,
                offsetBottom: seat.offsetBottom,
                showNumber: showNumber,
                onlyHandicapped: seat.onlyHandicapped
            };
            return React.createElement(Seat, __assign({ key: index }, props, { seat: seat }));
        });
        if (blanks.length > 0) {
            blanks.forEach(function (blank, index) {
                row.push(React.createElement(Blank, { key: row.length + index + 1, seat: null }));
            });
        }
        return row;
    };
    SeatPicker.defaultProps = {
        addSeatCallback: function (_a, addCb) {
            var row = _a.row, numero = _a.numero, id = _a.id;
            console.log("Added seat ".concat(numero, ", row ").concat(row, ", id ").concat(id));
            addCb(row, numero, id);
        },
        removeSeatCallback: function (_a, removeCb) {
            var row = _a.row, numero = _a.numero, id = _a.id;
            console.log("Removed seat ".concat(numero, ", row ").concat(row, ", id ").concat(id));
            removeCb(row, numero);
        },
        maxReservableSeats: 0,
    };
    return SeatPicker;
}(Component));
export { SeatPicker };



//////////////////
// WEBPACK FOOTER
// ./src/components/Seatmap/SeatPicker/SeaPicker.tsx
// module id = 1269
// module chunks = 0